import Axios from "axios";
import { getApiConfig } from "../../config/apiConfig";
import { adalApiFetch } from "../../config/azureConfig";
import { GET_CUSTOMER_FLAGS, GET_CUSTOMER_FLAGS_BY_IDS, UPDATE_CUSTOMER_FLAGS, DELETE_CUSTOMER_FLAGS, GET_CUSTOMER_FLAG } from "../constants/action-types";


const API_CONFIG = getApiConfig();

/* 
  Get Customer Flag list.
*/
export const getCustomerFlags = (callback) => dispatch => {
    adalApiFetch(Axios, `${API_CONFIG.URL}/customer-flags`, {
        method: "get"
    }).then(res => {
        dispatch({
            type: GET_CUSTOMER_FLAGS,
            payload: res.data
        });

        callback(true);
    }).catch((error) => {
        console.log(`Exception Occurred: ${error}`);
        callback(false);
    })
};

/* 
  Get a Customer Flag.
*/
export const getCustomerFlag = (customerFLagId, callback) => dispatch => {
    adalApiFetch(Axios, `${API_CONFIG.URL}/customer-flags/${customerFLagId}`, {
        method: "get"
    }).then(res => {
        dispatch({
            type: GET_CUSTOMER_FLAG,
            payload: res.data
        });

        callback(true);
    }).catch((error) => {
        console.log(`Exception Occurred: ${error}`);
        callback(false);
    })
};

/* 
  Get Customer Flag list by Ids.
*/
export const getCustomerFlagsForIds = (customerFlagIds, callback) => dispatch => {
    adalApiFetch(Axios, `${API_CONFIG.URL}/customer-flags?forIds=true`, {
        method: "post",
        data: customerFlagIds
    }).then(res => {
        dispatch({
            type: GET_CUSTOMER_FLAGS_BY_IDS,
            payload: res.data
        });

        callback(true);
    }).catch((error) => {
        console.log(`Exception Occurred: ${error}`);
        callback(false);
    })
};

/* 
  Create/Update a Customer Flag.
*/
export const upsertCustomerFlag = (customerFlag, callback) => dispatch => {
    adalApiFetch(Axios, `${API_CONFIG.URL}/customer-flags`, {
        method: "post",
        data: customerFlag
    }).then(res => {
        dispatch({
            type: UPDATE_CUSTOMER_FLAGS,
            payload: res.data
        });

        callback(true);
    }).catch((error) => {
        console.log(`Exception Occurred: ${error}`);
        callback(false);
    })
};

/* 
  Delete a Customer Flag
*/
export const deleteCustomerFlag = (customerFlagId, callback) => dispatch => {
    adalApiFetch(Axios, `${API_CONFIG.URL}/customer-flags/${customerFlagId}`, {
        method: "delete"
    }).then(res => {
        dispatch({
            type: DELETE_CUSTOMER_FLAGS,
            payload: res.data
        });

        callback(true);
    }).catch((error) => {
        console.log(`Exception Occurred: ${error}`);
        callback(false);
    })
};

/* 
  Delete a Customer Flag
*/
export const deleteCustomerFlags = (customerFlagIds, callback) => dispatch => {
    adalApiFetch(Axios, `${API_CONFIG.URL}/customer-flags`, {
        method: "delete",
        data: customerFlagIds
    }).then(res => {
        dispatch({
            type: DELETE_CUSTOMER_FLAGS,
            payload: res.data
        });

        callback(true);
    }).catch((error) => {
        console.log(`Exception Occurred: ${error}`);
        callback(false);
    })
};